import { Box } from '@common-fe/common-fe';
import styled from 'styled-components';

export const LabelWrap = styled(Box)`
  display: inline-block;
`;
